import { render, staticRenderFns } from "./storeData3.vue?vue&type=template&id=4545a50c&scoped=true&"
import script from "./storeData3.vue?vue&type=script&lang=js&"
export * from "./storeData3.vue?vue&type=script&lang=js&"
import style0 from "./storeData3.vue?vue&type=style&index=0&id=4545a50c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4545a50c",
  null
  
)

export default component.exports